<template>
  <div>
    <div :class="(loading ? 'show-loader' : 'hide-loader')">
      <div class="el-loading-spinner">
        <svg viewBox="25 25 50 50" class="circular">
          <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
        </svg><!---->
      </div>
    </div>
    <div class="reservations-top-bar category-top-bar" ref="optionsTopBar" >
      <div class="text-left">
        <h3>{{ $t('menuLink.reservations') }} <a class="btn btn-info btn-icon" @click.prevent="getData()"><i class="ti-reload" style="margin-right: 5px;"></i> Reload</a></h3>
      </div>
      <div class="text-right">
        <!-- <a class="btn btn-info btn-icon"  @click.prevent="goToAdd"><i class="ti-plus"></i> Adauga Rezervare</a> -->
        <!-- <p class=""> -->
          <!-- <a class="btn btn-info btn-icon"  @click.prevent="goToAdd" :title="$t('general.add') + ' ' + $t('settingUsers.single')"><i class="ti-plus"></i></a> -->
        <!-- </p> -->
      </div>
    </div>
    <div style="display: flex;">
      <div class="tableWrapper">
        <template v-for="table in tableData">
          <div class="card table_card mar-to-15">
            <div class="card-content">

              <div class="title">
                <span>{{table.id}} {{table.zone}} {{table.type}} {{table.number}} (max:{{table.max_pers}})</span>
                <span class="min_max_pers">min_pers: {{table.min_pers || 0}} - max_pers: {{table.max_pers}}</span>
                <hr style="margin: 0;">
              </div>

              <div class="reservations">
                <template v-for="resTable in table.reservations_table">
                  <div class="reservation" v-if="resTable.reservations">
                    <span class="reservation_id">ID: {{resTable.reservations.id}}</span>
                    <div class="reservation_data">
                      <table style="text-align: center; margin: 0;">
                         <tr>
                            <td colspan="2">{{formatDateToShowJustDate(resTable.reservations.date_from)}}</td>
                          </tr>
                          <tr>
                            <td>{{formatDateToShowJustTime(resTable.reservations.date_from)}}</td>
                            <td>{{formatDateToShowJustTime(resTable.reservations.date_to)}}</td>
                          </tr>
                      </table>
                      <!-- <span>{{formatDateToShowJustDate(resTable.reservations.date_from)}} - {{formatDateToShowJustTime(resTable.reservations.date_from)}} - {{formatDateToShowJustTime(resTable.reservations.date_to)}}</span> -->
                    </div>
                    <div class="reservation_data statuses">
                      <template v-if="resTable.reservations.status != 'RESERVED'">
                        <button :class="['statusBtn RESERVED']" @click="changeStatus('RESERVED', resTable)">RESERVED</button>
                        <button :class="['statusBtn CANCELED']" @click="changeStatus('CANCELED', resTable)">CANCELED</button>
                      </template>
                      <template v-else>
                        <template v-for="sts in statuses">
                          <template v-if="resTable.reservations.status == 'RESERVED' && sts != resTable.reservations.status">
                            <button :class="['statusBtn',
                                              sts,
                                              resTable.reservations.status == sts ? 'active' : ''
                                            ]" @click="changeStatus(sts, resTable)">{{sts}}</button>
                          </template>
                        </template>
                      </template>
                    </div>
                    <div class="reservation_user">
                      <span>Name: {{resTable.reservations.name}}</span>
                      <span>Email: {{resTable.reservations.email}}</span>
                      <span>Phone: {{resTable.reservations.phone}}</span>
                      <span>Total Persoane: {{resTable.reservations.total_pers}}</span>
                    </div>
                    <div class="reservation_data">
                      <table class="reservation_prices">
                        <tr>
                          <th>Name</th>
                          <th>Price</th>
                        </tr>
                        <template v-for="resItems in resTable.reservations_items">
                          <tr>
                            <td>{{resItems.name}}</td>
                            <td>{{resItems.price}}</td>
                          </tr>
                        </template>
                        <tr>
                          <th>Total Masa:</th>
                          <th>{{resTable.table_total_price}}</th>
                        </tr>
                        <tr>
                          <th>Total Rezervare:</th>
                          <th>{{resTable.reservations.total_price}}</th>
                        </tr>
                        <tr>
                          <td>Payment Type:</td>
                          <td>{{resTable.reservations.payment_type}}</td>
                        </tr>
                      </table>
                    </div>
                  </div>

                </template>
              </div>

            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import moment from 'moment'
  import {Input, Table, TableColumn, Option, Pagination} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  // import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  Vue.use(Input)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Option)
  Vue.use(Pagination)
  Vue.use(DataTables)
  export default {
    components: {
      PPagination,
      [Input.name]: Input
    },
    props: {

    },
    created () {
      this.apiUrl = process.env.API_BASE_URL
      this.token = this.$session.get('token')
      this.getData()
    },
    data () {
      return {
        statuses: ['RESERVED', 'COMPLETED', 'CANCELED'],
        loading: true,
        token: null,
        apiUrl: null,
        locationDataForTableManagement: [],
        tableData: []
      }
    },
    methods: {
      getData () {
        this.loading = true
        var data = {
          token: this.token,
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/get-table-reservations', 'GET', data, (response) => {
          if (response.status === true) {
            this.tableData = response.data.tables

            this.$nextTick(() => {
              this.loading = false
            })
          }
        })
      },
      changeStatus (sts, resTable) {
        this.loading = true
        var data = {
          token: this.token,
          company_id: this.$session.get('selectedCompany'),
          status: sts,
          reservation_id: resTable.reservations.id
        }
        this.apiRequest('/edit-reservation', 'GET', data, (response) => {
          if (response.status === true) {
            this.tableData = response.data.tables

            this.$nextTick(() => {
              this.loading = false
            })
          }
        })
      },
      formatDateToShowJustDate (date) {
        return moment(date).format('DD-MM-YYYY')
      },
      formatDateToShowJustTime (date) {
        return moment(date).format('hh:mm A')
      },
      copyToClipboard (textToCopy) {
        textToCopy = textToCopy.replace(/\s/g, '')
        this.$copyText(textToCopy).then(function (e) {
          // alert('Copied')
          // console.log(e)
        }, function (e) {
          // console.log('Can not copy')
          // console.log(e)
        })
      }
    }
  }
</script>
<style scoped lang="scss">
  .min_max_pers {
    display: block;
    display: none;
  }
  .tableWrapper {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }
  .table_card {
    width: calc(25% - 20px);
    margin-left: 10px;
    margin-right: 10px;
    @media screen and (max-width: 1700px) {
      width: calc(33.33% - 20px);
    }
    @media screen and (max-width: 1200px) {
      width: calc(50% - 20px);
    }
    @media screen and (max-width: 920px) {
      width: calc(100% - 20px);
    }
  }
  .reservation {
    position: relative;
    background: #f2f2f2;
    padding: 10px;
    margin-top: 20px;
    margin-bottom: 20px;
    .reservation_id {
      position: absolute;
      right: 0;
      bottom: 0;
    }
    .reservation_prices {
      td, th {
        border: 1px solid #dddddd;
        text-align: left;
        padding: 8px;
      }
      tr:nth-child(even) {
        background-color: #dddddd;
      }
    }
    .rezItems {
      display: flex;
      flex-direction: column;
    }
    .reservation_data,
    .reservation_user {
      margin-top: 10px;
      margin-bottom: 10px;
      display: flex;
      flex-direction: column;
    }
    .statuses {
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }
    .statusBtn {
      font-weight: bold;
      padding: 5px 10px;
      width: calc(50% - 10px);
      margin-bottom: 10px;
      margin-left: 5px;
      margin-right: 5px;
      transition: 0.5s;
      border-radius: 20px;
      &.NEW {
        color: #68B3C8;
        border: 3px solid #68B3C8;
      }
      &.RESERVED {
        color: #F3BB45;
        border: 3px solid #F3BB45;
      }
      &.COMPLETED {
        color: #7AC29A;
        border: 3px solid #7AC29A;
      }
      &.CANCELED {
        color: #EB5E28;
        border: 3px solid #EB5E28;
      }
      &:hover,
      &.active {
        color: #fff;
        transition: 0.5s;
        &.NEW {
          background-color: #68B3C8;
        }
        &.RESERVED {
          background-color: #F3BB45;
        }
        &.COMPLETED {
          background-color: #7AC29A;
        }
        &.CANCELED {
          background-color: #EB5E28;
        }
      }
    }
  }
  .reservations-top-bar {
    // height: 75px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    h2 {
      margin: 0;
    }
  }
  .copy_link {
    width: 100%;
  }
  .middle {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reservations/Reservations.vue